import { render, staticRenderFns } from "./ModaEventEdit.vue?vue&type=template&id=3d687143&"
import script from "./ModaEventEdit.vue?vue&type=script&lang=js&"
export * from "./ModaEventEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports